export default __webpack_public_path__ + "img/favicons/apple-touch-icon-144x144.png";